import React from 'react';
import Container from 'components/UI/Container';
import Image from 'components/UI/Image';
import Title from 'components/UI/Title';
import Subtitle from 'components/UI/Subtitle';
import { replaceKeyword } from 'utils';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './CoreValues.module.scss';

function CoreValues({ img, title, description, items }) {
  return (
    <Container id="our-values" background="transparent" className={styles.container}>
      <Image
        aria-hidden="true"
        className={styles.picture}
        classImage={styles.image}
        src={img}
        alt=""
      />
      <div className={styles.layout}>
        <Title className={styles.title} color="white">
          {title}
        </Title>
        <Subtitle className={styles.subtitle} color="white">
          {description}
        </Subtitle>
        <div className={styles.statsRow}>
          {items.map(({ count, countDescription }, i) => (
            <div className={styles.statItem} key={i}>
              <span className={styles.statValue}>{replaceKeyword(count)}</span>
              <span className={styles.statLabel}>{countDescription}</span>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
}

CoreValues.displayName = 'CoreValues';

export default withErrorBoundary(CoreValues);
